import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "send", "status"]
  static values = {
    pending: { type: String, default: "Sending…" },
    failure: { type: String, default: "Couldn't send. Please try again." }
  }

  connect() {
    this.submitting = false
    this.update()
  }

  update() {
    this.sendTarget.disabled = this.submitting || !this.bodyTarget.value.trim()
  }

  keydown(event) {
    if (event.key !== "Enter" || event.shiftKey || event.isComposing || event.keyCode === 229) return

    event.preventDefault()
    if (!event.repeat && !this.submitting && this.bodyTarget.value.trim()) {
      this.element.requestSubmit(this.sendTarget)
    }
  }

  submit(event) {
    if (this.submitting || !this.bodyTarget.value.trim()) {
      event.preventDefault()
      return
    }

    this.submitting = true
    this.bodyTarget.readOnly = true
    this.statusTarget.textContent = this.pendingValue
    this.update()
  }

  finish(event) {
    this.submitting = false
    this.bodyTarget.readOnly = false
    this.statusTarget.textContent = event.detail.success ? "" : this.failureValue
    this.update()
  }
}
